const locale = {
    VehicleVIOReport: "Fordon VIO-rapport",
    ArticleVIOReport: "Artikel VIO-rapport",
    History: "Historia",
    UserManagement: "Användarhantering",
    FirstName: "Förnamn",
    Email: "E-post",
    Region: "Område",
    Year: "År",
    Month: "Månad",
    DownloadDate: "Ladda ned datum",
    Type: "Typ"
}

export default locale;
